// extracted by mini-css-extract-plugin
module.exports = {"container":"packages-primitives-PortalError-style__container--1X3YU"};